export function generateUniqueId() {
    const uId = performance.now().toString();
    return uId.replace('.', '');
}

// https://basarat.gitbook.io/typescript/type-system/typeguard#user-defined-type-guards
function isStringArray(list: any): list is string[] {
    if (Array.isArray(list) && list.every((x) => typeof x === 'string')) {
        return true;
    }
    return false;
}

// window.topContext.user.getActiveUser().customerIdList can be string or string[]
// this function will convert it to string[] if needed.
export function customerIdListToArray(list: string | string[]): string[] {
    if (isStringArray(list)) {
        return list;
    } else {
        const customerIdList = list.split(',');
        if (customerIdList.length === 1 && customerIdList[0] === '') {
            return [];
        }
        return customerIdList;
    }
}

// is a zipcode for Bornholm?
export function isBornholm(zipCode: number | string): boolean {
    if (typeof zipCode === 'number') {
        return zipCode >= 3700 && zipCode <= 3799;
    }
    if (typeof zipCode === 'string') {
        return /^37\d{2}$/.test(zipCode);
    }
    return false;
}

// remove trailings slashes from string
export function stripTrailingSlashes(str: string) {
    while (str.endsWith('/')) {
        str = str.slice(0, -1);
    }
    return str;
}

/*
 * About Names from gti-services
 * gti-services encodes names in ALLCAPS. The firstName field contains 1 or more nameparts, separated by space. This
 * is the firstname[fornavn] and middlesnames[mellemnavne], sometimes just called firstnames[fornavne].
 * The lastName field contains exactly one namepart.
 * A namepart is a name, fx 'MADS'
 * or several names concatenated with '-', fx 'MADS-PETER' or 'ANDERSEN-SKJERN'.
 */

// uppercase first letter and lowercase the rest
export function uppercaseFirst(text: string): string {
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
}

// upercase a name
export function uppercaseName(text: string): string {
    const names = text.split('-');
    const namesUppercasefirst = names.map(uppercaseFirst);
    const result = namesUppercasefirst.join('-');
    return result;
}

// uppercase names seperated by space, used for firstname(s)
export function uppercaseNames(text: string): string {
    const names = text.split(' ');
    const namesUppercasefirst = names.map(uppercaseName);
    const result = namesUppercasefirst.join(' ');
    return result;
}

// display the full name with data from gti-services
export function displayFullName(firstName: string, lastName: string) {
    return `${uppercaseNames(firstName)} ${uppercaseName(lastName)}`;
}

// display the full address with data from gti-services
export function displayFullAddress(streetAddress: string, zipCity: string, village?: string) {
    village = village ? `${village}, ` : '';
    return `${streetAddress}, ${village}${zipCity}`;
}
